import store from '@/store'
import router from '@/router'
import { Notification,MessageBox } from 'element-ui'

class Base {
  /**
   * 初始化
   */
  constructor() {
    this.$notify = Notification
	this.$message = MessageBox
  }

  getStoreInstance() {
    return store
  }

  /**
   * 获取当前登录用户的ID
   */
  getAccountId() {
    return store.state.userInfo.userId
  }
  /**
   * 获取当前会话信息
   */
  getTalkParams() {
    let session_id = store.state.imChatService.index_name;
	return {
		session_id:session_id
	}
  }

  /**
   * 判断消息是否来自当前对话
   *
   * 
   * @param {String} session_id 当前会话id
   * 
   */
  isTalk(source) {
    let params = this.getTalkParams()
	if (source.session_id == params.session_id) {
		return true;
    } 
    return false
  }

  /**
   * 判断用户是否打开对话页
   */
  isTalkPage() {
    let path = router.currentRoute.path
    return !(path != '/im/index')
  }
}

export default Base
